import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import 'rc-slider/assets/index.css';
import { cloneDeep } from 'lodash';
import { Button } from 'react-bootstrap';
import { CarStatus } from '@upstart/harmony/lib/constants';
import WidgetService from '../../../services/WidgetService';
import PricingButtonGroupEditor from '../WebsiteWidgetConfigEditor/editors/PricingButtonGroupEditor';
import StandaloneButtonsEditor from '../WebsiteWidgetConfigEditor/editors/StandaloneButtonsEditor';
import APIEditor from '../WebsiteWidgetConfigEditor/editors/APIEditor';
import feedviewsActions from '../../../redux/feedviews/actions';
import websiteActions from '../../../redux/websites/actions';
import WebsiteWidgetConfigEditor from '../WebsiteWidgetConfigEditor/WebsiteWidgetConfigEditor';
import WebsitePreviewButtonModal from '../WebsiteWidgetConfigEditor/WebsitePreviewButtonModal';
import { getWidgetButtonCssClass } from '../../../util/constants';
import '../Website.scss';

// Dummy Preview Data
const CAR = {
  id: '4T1C31AK9LU527263',
  msrp: '15299',
  dealer_id: 'victorytoyota',
  status: CarStatus.AVAILABLE,
};

function WebsiteButtons(props) {
  const WIDGET_EDITOR_TAB_LIST = [
    {
      name: 'Vehicle Detail',
      title: 'Vehicle Detail Pricing Button Group',
      type: 'VDP',
      editor: PricingButtonGroupEditor,
    },
    {
      name: 'Search Results',
      title: 'Search Results Pricing Button Group',
      type: 'SRP',
      editor: PricingButtonGroupEditor,
    },
    {
      name: 'Standalone Buttons',
      title: 'Standalone Buttons',
      type: 'STANDALONE',
      editor: StandaloneButtonsEditor,
    },
    {
      name: 'Widget API',
      title: 'Widget API',
      type: 'API',
      editor: APIEditor,
    },
  ];

  const { website, actions, history, match, fetching, tmpWebsite } = props;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [previewHTML, setPreviewHTML] = useState('');
  const [previewCSS, setPreviewCSS] = useState('');

  useEffect(() => {
    if (website.id) {
      actions.updateWebsiteTmpRequest({ tmpWebsite: website });
    }
  }, [website]);

  const getActiveTab = () => {
    const url = match.url.split('/');
    const tab = url[url.length - 1];

    switch (tab) {
      case 'vdp':
        return WIDGET_EDITOR_TAB_LIST[0];
      case 'srp':
        return WIDGET_EDITOR_TAB_LIST[1];
      case 'standalone':
        return WIDGET_EDITOR_TAB_LIST[2];
      case 'api':
        return WIDGET_EDITOR_TAB_LIST[3];
      default:
        return WIDGET_EDITOR_TAB_LIST[0];
    }
  };

  const onPageSave = (widgetConfig, type) => {
    const config = widgetConfig[type];
    WidgetService.getButtonGroupsPreview({
      car: CAR,
      config,
      website,
    }).then((resp) => {
      setPreviewHTML(
        `<div class="prodigy-pricing-button-group">${
          resp.buttonGroups[CAR.id]
        }</div>`,
      );
      setPreviewCSS(resp.CSS);
      setModalIsOpen(true);
    });
  };

  const onStandaloneSave = (widgetConfig) => {
    const config = widgetConfig.STANDALONE;
    WidgetService.getStandaloneButtonsPreview({
      config,
    }).then((resp) => {
      setPreviewHTML(
        Object.entries(resp.standaloneButtons)
          .filter(([key]) => getWidgetButtonCssClass(key))
          .map(
            ([key, value]) => `
          <div class="${getWidgetButtonCssClass(key)}">
            ${value}
          </div>`,
          )
          .join(''),
      );
      setPreviewCSS(resp.CSS);
      setModalIsOpen(true);
    });
  };

  const onChangeData = (formData) => {
    const tmpWebsiteClone = cloneDeep(tmpWebsite);
    tmpWebsiteClone.widgetConfig = formData;
    actions.updateWebsiteTmpRequest({ tmpWebsite: tmpWebsiteClone });
  };

  const cancel = () => {
    history.push('/websites/');
  };

  const preview = () => {
    const activeType = getActiveTab().type;
    if (['SRP', 'VDP'].indexOf(activeType) > -1) {
      onPageSave(tmpWebsite.widgetConfig, activeType);
    } else {
      onStandaloneSave(tmpWebsite.widgetConfig);
    }
  };

  const saveConfig = () => {
    const updatedWebsite = cloneDeep(tmpWebsite);
    updatedWebsite.widgetConfig = tmpWebsite.widgetConfig;
    actions.updateWebsiteRequest({ website: updatedWebsite });
  };

  return (
    <div className="website-tab-container">
      <h3>{getActiveTab().title}</h3>
      <div className="tab-main-content-container">
        <WebsiteWidgetConfigEditor
          website={website}
          fetching={fetching}
          onChange={onChangeData}
          widgetConfig={{ ...website.widgetConfig }}
          page={getActiveTab()}
        />
        {modalIsOpen && (
          <WebsitePreviewButtonModal
            saveModal={() => {
              setModalIsOpen(false);
              saveConfig();
            }}
            cancelModal={() => setModalIsOpen(false)}
            html={previewHTML}
            css={previewCSS}
            activeTab={getActiveTab()}
          />
        )}
      </div>
      <div className="row submit-button-row">
        <div>
          <Button bsClass="btn" onClick={cancel}>
            Cancel
          </Button>
        </div>
        <div>
          {getActiveTab().type !== 'API' && (
            <Button bsClass="btn btn-primary" onClick={preview}>
              Preview
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

WebsiteButtons.propTypes = {
  website: PropTypes.array,
  fetching: PropTypes.bool,
  actions: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
  tmpWebsite: PropTypes.object,
};

const mapStateToProps = (state) => ({
  feeds: state.feeds.feeds,
  fetching: state.websites.fetching,
  tmpWebsite: state.websites.tmpWebsite,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...feedviewsActions,
      ...websiteActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(WebsiteButtons);
